import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Backdrop,
  // CircularProgress
} from '@mui/material';
import PropTypes from 'prop-types';
import EarningCard from './EarningCard';
import { stockData } from 'API/Stock';

const Index = () => {
  // Date setup
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const formatDate = (date) => date.toISOString().split('T')[0];

  const [fromDate, setFromDate] = useState(formatDate(oneMonthAgo));
  const [toDate, setToDate] = useState(formatDate(today));
  const [stockInfo, setStockInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  //API call on date change
  useEffect(() => {
    if (fromDate && toDate) {
      setIsLoading(true);

      stockData(fromDate, toDate)
        .then((data) => {
          console.log('Full API Response:', data);
          if (data?.stocks) {
            setTimeout(() => {
              setStockInfo(data.stocks);
              setIsLoading(false);
            }, 500); // Simulated Delay
          } else {
            setIsLoading(false);
          }
        })
        .catch(() => setIsLoading(false));
    }
  }, [fromDate, toDate]);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box mt={1}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  return (
    <>
      {/* Backdrop Loader */}
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 10
        }}
        open={isLoading}
      >
        {/* <CircularProgress color="inherit" /> */}
      </Backdrop>

      {/* Section Heading */}
      <Box
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          px: 1.5,
          py: 1,
          mb: 1.5,
          backgroundColor: '#fafafa'
        }}
      >
        <Grid container spacing={1.5} alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h5"
              fontWeight={500}
              color="#592375"
              sx={{ fontSize: { xs: '0.7rem', sm: '0.95rem', md: '1.1rem' } }}
            >
              Stock Dashboard
            </Typography>
          </Grid>

          <Grid item xs={12} md>
            <Grid
              container
              spacing={2}
              justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
              alignItems="center"
              wrap="wrap"
            >
              <Grid item>
                <TextField
                  type="date"
                  label="From Date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 110, maxWidth: 120 }}
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  InputProps={{
                    sx: { fontSize: '0.75rem', height: 36 }
                  }}
                  inputProps={{
                    style: { fontSize: '0.75rem' }
                  }}
                />
              </Grid>

              <Grid item>
                <TextField
                  type="date"
                  label="To Date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 110, maxWidth: 120 }}
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  InputProps={{
                    sx: { fontSize: '0.75rem', height: 36 }
                  }}
                  inputProps={{
                    style: { fontSize: '0.75rem' },
                    max: formatDate(today)
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* Metrics Section */}
      <EarningCard stockInfo={stockInfo} isLoading={isLoading} />
    </>
  );
};

export default Index;
